<template>
    <node :title="config.name" :show-error="showError" :content="content" :error-info="errorInfo" :isProcess="isProcess"
        @selected="$emit('selected')" @delNode="$emit('delNode')" @insertNode="type => $emit('insertNode', type)"
        placeholder="请设置抄送人" header-bgc="#2D5DCF" header-icon="el-icon-s-promotion"/>
</template>

<script>
import Node from './Node'

export default {
  name: "CcNode",
  props:{
    isProcess: {
      type: Boolean,
      default: false
    },
    config:{
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: {Node},
  created() {
    this.$bus.$on('updateNodeText', this.updateNodeText);
  },
  beforeDestroy() {
    this.$bus.$off('updateNodeText', this.updateNodeText);
},
  data() {
    return {
      showError: false,
      errorInfo: '',
      // 添加localConfig作为props.config的本地副本
      localConfig: JSON.parse(JSON.stringify(this.config))
    }
  },
  computed:{
    content() {
      const config = this.localConfig.props || {}
      let text = ''
      switch (config.assignedType){
        case "ASSIGN_USER":
          if (config.assignedUser.length > 0){
            let texts = []
            config.assignedUser.forEach(org => texts.push(org.name))
            text =  String(texts).replaceAll(',', '、')
          }else {
            text =  '请指定抄送人'
          }
          break;
        case "DEPT_LEADER":
          text = '发起人的第' + config.leader.level + '级主管'
          break;
        case "LEADER":
          text =  '发起人的直接上级'
          break;
        case "ROLE":
          if (config.role.length > 0){
            let texts = []
            config.role.forEach(org => texts.push(org.name))
            text =  String(texts).replaceAll(',', '、')
          }else {
            text =  '指定角色（未设置）'
          }
          break;
          default: text =  '未知设置项'
      }
      if (config.shouldAdd){
        return text ? `${text} + 发起人添加` : '发起人添加';
      }
      return text
    }
  },
  methods: {
    updateNodeText(){
      // 改为修改localConfig而不是直接修改props.config
      this.localConfig = {...this.config}
    },
    //校验数据配置的合法性
    validate(err){
      this.showError = false
      if(this.config.props.shouldAdd || this.config.props.assignedType ==='LEADER'){
        this.showError = false
      }else if(this.config.props.assignedType === 'ASSIGN_USER' && this.config.props.assignedUser.length === 0){
        this.showError = true
        this.errorInfo = '未指定抄送人员'
      }else if(this.config.props.assignedType === 'ROLE' && this.config.props.role.length === 0){
        this.showError = true
        this.errorInfo = '未指定抄送角色'
      }
      if (this.showError){
        err.push(`${this.config.name} ${this.errorInfo}`)
      }
      return !this.showError
    }
  }
}
</script>

<style scoped>

</style>
